<svg class="icon {{ classList }}">
  <!-- <use [attr.xlink:href]="name" [attr.fill]="color"></use> -->
  <use [attr.xlink:href]="name"></use>
</svg>
